import * as XLSX from "xlsx";
import {saveWorkbook} from "../../../utils/excel";

const HEADER = ['規則總數', '規則清單之關鍵字涵蓋']

export const useExportRules = ({
  data,
}) => {
  // export cases detail to excel file
  const exportData = () => {
    const workbook = XLSX.utils.book_new();
    const values = []

    values.push(HEADER)
    if (data.length === 0) {
      values.push([0, ''])
    } else {
      values.push([data.length, data[0].match.keywords.join(', ')])
    }

    for (let i=1; i<data.length; i++){
      values.push([
        '',
        data[i].match.keywords.join(', '),
      ])
    }
    const worksheet = XLSX.utils.aoa_to_sheet(values);
    XLSX.utils.book_append_sheet(workbook, worksheet, '總表');
    saveWorkbook({ workbook, fileName: '聊天機器人規則總表'})
  }
  return { exportData }
}
